// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__2Lhss","balanceDisclaimer":"posDashboard_balanceDisclaimer__6wY3M"};